var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17551 1.95939L1.70218 7.75272C1.49551 7.97272 1.29551 8.40606 1.25551 8.70606L1.00885 10.8661C0.92218 11.6461 1.48218 12.1794 2.25551 12.0461L4.40218 11.6794C4.70218 11.6261 5.12218 11.4061 5.32885 11.1794L10.8022 5.38606C11.7488 4.38606 12.1755 3.24606 10.7022 1.85272C9.23551 0.472723 8.12218 0.959389 7.17551 1.95939Z",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26172 2.92627C6.54839 4.76627 8.04172 6.17294 9.89505 6.3596",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.9ad461fa75df26b4c0378d598e7615de.svg";
export { ForwardRef as ReactComponent };